import { render, staticRenderFns } from "./GridText.vue?vue&type=template&id=0dc76e3a"
import script from "./GridText.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridText.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports